<script>
  import MacFinder from "../components/MacFinder.svelte";

  import Modal from "../components/Modal.svelte";
  import Load from "../components/Load.svelte";
  import { fade } from "svelte/transition";
  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  import LoadSquare from "../components/LoadSquare.svelte";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];

  let alertMessage = "Proses berlangsung";
  let alertType = "2";

  export let json;
  let loading = true;
  let loadingscuare = false;
  setTimeout(() => {
    loading = false;
  }, 2000);

  let sessionhotspot = json.id;
  let user = "";
  let pass = "";
  let result = false;
  let autoRefresh = false;
  async function handleSubmit(withloading = true) {
    if (withloading) {
      loading = true;
    }
    axios
      .post(
        settings.url + "/sipade/hotspot-active?authorization=" + settings.token,
        {
          server: sessionhotspot,
          username: user,
          password: pass,
        }
      )
      .then(function (response) {
        if (withloading == false) {
          loadingscuare = false;
        }
        if (response.data.message) {
          alertMessage = response.data.message;
          alert = [
            ...alert,
            { title: "Dekatan", message: alertMessage, color: "orange" },
          ];
        } else {
          if (response.data.user) {
            result = response.data;
          }
          autoRefresh = true;
        }
      })
      .catch(function (error) {
        alert = [
          ...alert,
          {
            title: "Dekatan",
            message: error.response.data.message,
            color: "orange",
          },
        ];
        //location.reload();
      })
      .then(function () {
        loading = false;
        // always executed
      });
  }
  $: if (autoRefresh) {
    setTimeout(() => {
      handleSubmit(false);
      autoRefresh = false;
    }, 10000);
  }

  let idRemove;
  async function handleRemove(event) {
    loadingscuare = true;

    axios
      .post(
        settings.url + "/sipade/hotspot-remove?authorization=" + settings.token,
        {
          server: sessionhotspot,
          username: user,
          password: pass,
          selection: idRemove,
        }
      )
      .then(function (response) {
        loadingscuare = false;
        handleSubmit(false);
        if (response.data) {
          alertMessage = "Berhasil Menonaktifkan Koneksi";
          alert = [
            ...alert,
            { title: "Dekatan", message: alertMessage, color: "green" },
          ];
        } else {
          alertMessage = "Gagal Menonaktifkan Koneksi";
          alert = [
            ...alert,
            { title: "Dekatan", message: alertMessage, color: "orange" },
          ];
        }
      })
      .catch(function (error) {
        loadingscuare = false;
        handleSubmit(false);
        alert = [
          ...alert,
          {
            title: "Dekatan",
            message: error.response.data.message,
            color: "red",
          },
        ];
      });
  }

  async function handleRemoveAll(event) {
    loadingscuare = true;

    axios
      .post(
        settings.url + "/sipade/hotspot-remove?authorization=" + settings.token,
        {
          server: sessionhotspot,
          username: user,
          password: pass,
        }
      )
      .then(function (response) {
        handleSubmit(false);

        if (response.data) {
          alertMessage = "Berhasil Mencabut Semua Sesi Koneksi";
          alert = [
            ...alert,
            { title: "Dekatan", message: alertMessage, color: "green" },
          ];
        } else {
          alertMessage = "Gagal Menonaktifkan Sesi Koneksi";
          alert = [
            ...alert,
            { title: "Dekatan", message: alertMessage, color: "orange" },
          ];
        }
      })
      .catch(function (error) {
        loadingscuare = false;
        handleSubmit(false);
        alert = [
          ...alert,
          {
            title: "Dekatan",
            message: error.response.data.message,
            color: "red",
          },
        ];
      });
  }
</script>

<svelte:head>
  <title>Kelola Akun Hotspot - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div
    class="fixed bottom-0 left-0 right-0 z-10 w-full px-2 mb-10 lg:left-auto lg:w-3/12"
  >
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  message={navigation["message"]}
  title="Hotspot Monitor"
/>

<main
  transition:fade
  class="container px-2 pt-24 mx-auto mb-20 lg:pt-32 md:pt-16"
>
  {#if loading}
    <Load />
    <div
      class="fixed top-0 left-0 right-0 z-50 w-screen h-2 bg-green-500 animate-pulse"
    />
  {/if}
  {#if loadingscuare}
    <LoadSquare title="Sedang Mencabut Sesi..." />
    <div
      class="fixed top-0 left-0 right-0 z-50 w-screen h-2 bg-green-500 animate-pulse"
    />
  {/if}
  {#if result}
    <div class="max-w-4xl mx-auto overflow-x-auto rounded-lg">
      <div
        class="flex flex-wrap items-center max-w-6xl mx-auto my-5 lg:my-0 "
        style=""
      >
        <div class="w-full mx-auto mb-2">
          <div
            class="block px-4 py-3 bg-white rounded-md shadow-md cursor-pointer group"
          >
            <div class="flex items-center justify-between">
              <span class="text-xl font-bold text-gray-800">
                {result.user.name}
              </span>
              {#if result.user.limitUptime == "1s"}
                <span
                  class="px-3 py-0 text-xs text-red-800 bg-red-200 rounded-full"
                >
                  Expired
                </span>
              {:else}
                <span
                  class="px-3 py-0 text-xs text-green-800 bg-green-200 rounded-full"
                >
                  Aktif
                </span>
              {/if}
            </div>
            <div class="flex items-center justify-between w-full">
              <div>
                <small>Paket</small>
                <h2
                  class="text-sm font-semibold lg:text-lg group-hover:text-green-700"
                >
                  {result.user.profile}
                </h2>
              </div>
              <div>
                <small>Pemakaian</small>
                <h2
                  class="text-sm font-semibold lg:text-lg group-hover:text-green-700"
                >
                  {#if result.user.bytesOut + result.user.bytesIn == 0}
                    Dalam Proses
                  {:else}
                    {result.user.bytesOut + result.user.bytesIn}
                  {/if}
                </h2>
              </div>
              <div>
                <small>Sisa Data</small>
                <h2
                  class="text-sm font-semibold lg:text-lg group-hover:text-green-700"
                >
                  Unlimited
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {#if result.user_loged.length > 0}
      <div class="max-w-4xl mx-auto overflow-x-auto rounded-lg">
        <div class="flex flex-wrap items-center max-w-6xl mx-auto">
          <div class="w-full mx-auto mb-2">
            <div
              class="block px-4 py-3 bg-white rounded-md shadow-md cursor-pointer group"
            >
              <Modal backdropClose size="lg:w-2/6 w-full">
                <div slot="trigger" let:open>
                  <button
                    on:click={open}
                    type="button"
                    class="w-full px-5 py-2 text-gray-100 bg-orange-600 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
                  >
                    Cabut Semua Sesi
                  </button>
                </div>
                <div slot="header">
                  <h1 class="text-lg">Peringatan</h1>
                  <b>Silahkan konfirmasi</b>
                </div>
                <div slot="content">
                  <div class="mx-2 my-4 text-sm">
                    <div
                      class="p-4 my-4 font-light text-green-700 bg-green-100 border-l-4 border-green-600 rounded-lg shadow lg:mx-2"
                    >
                      Jika kamu yakin untuk mencabut semua sesi yang aktif,
                      silahkan klik tombol "Yakin...".
                      <hr class="my-2" />
                      <button
                        on:click={handleRemoveAll}
                        on:click={() =>
                          document
                            .getElementsByClassName("backdrop")[0]
                            .click()}
                        class="w-full px-4 py-2 mx-1 my-1 text-lg text-gray-200 bg-orange-500 rounded-full shadow-md cursor-pointer hover:shadow focus:bg-gray-500 focus:outline-none"
                        ><span><b>Yakin</b>, Cabut Semua Sesi..!</span></button
                      >
                    </div>
                    <hr class="my-2" />
                    <p class="py-2">
                      <i
                        >Catatan :<br />
                        Perlu diperhatikan, bahwa jika sesi dicabut perangkat terkait
                        harus melakukan otentikasi ulang pada jaringan hotspot untuk
                        kembali terhubung dan aktif<i /></i
                      >
                    </p>
                  </div>
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    {/if}

    <div class="max-w-4xl mx-auto overflow-x-auto rounded-lg">
      <div class="inline-block min-w-full overflow-hidden rounded-lg shadow">
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200"
              >
                Cabut
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200"
              >
                Alamat IP
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200"
              >
                Alamat MAC
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200"
              >
                Uptime
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200"
              >
                Idle Time
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200"
              >
                Bytes In
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200"
              >
                Bytes Out
              </th>
            </tr>
          </thead>
          <tbody>
            {#if result.user_loged}
              {#each result.user_loged as us}
                <tr>
                  <td
                    class="px-5 py-5 text-sm text-center bg-white border-b border-gray-200"
                  >
                    <button
                      class="w-5 h-5 m-auto rounded-full hover:bg-red-600"
                      on:click={() => (idRemove = us.id)}
                      on:click={handleRemove}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0
                          20zm5-11H5v2h10V9z"
                        />
                      </svg>
                    </button>
                  </td>
                  <td
                    class="px-5 py-5 text-sm bg-white border-b border-gray-200"
                  >
                    {us.user}
                    <br />
                    {us.address}
                  </td>
                  <td
                    class="px-5 py-5 text-sm bg-white border-b border-gray-200"
                    ><i>{us.macAddress}</i><br />
                    <MacFinder server={sessionhotspot} mac={us.macAddress} />
                  </td>
                  <td
                    class="px-5 py-5 text-sm bg-white border-b border-gray-200"
                  >
                    {us.uptime}
                  </td>
                  <td
                    class="px-5 py-5 text-sm bg-white border-b border-gray-200"
                  >
                    {us.idleTime}
                  </td>
                  <td
                    class="px-5 py-5 text-sm bg-white border-b border-gray-200"
                  >
                    {us.bytesIn}
                  </td>
                  <td
                    class="px-5 py-5 text-sm bg-white border-b border-gray-200"
                  >
                    {us.bytesOut}
                  </td>
                </tr>
              {/each}
            {/if}
          </tbody>
        </table>
      </div>
    </div>
  {:else}
    <div class="my-10 lg:my-0 ">
      <form
        autocomplete="off"
        class="w-full mx-auto mt-10 md:w-1/3"
        on:submit|preventDefault={handleSubmit}
      >
        <div class="flex justify-center font-bold">
          <svg
            class="inline-block w-16 h-16 text-gray-800 bg-white border-2 border-orange-400 rounded-full stroke-current"
            xmlns="http://www.w3.org/2000/svg"
            version="1"
            viewBox="0 0 48 48"
            enable-background="new 0 0 48 48"
          >
            <path
              fill="#E38939"
              d="M12,40V8c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H16C13.8,44,12,42.2,12,40z"
            />
            <path
              fill="#FFF3E0"
              d="M32,7H16c-0.6,0-1,0.4-1,1v29c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8C33,7.4,32.6,7,32,7z"
            />
            <circle fill="#A6642A" cx="24" cy="41" r="1.5" />
            <circle fill="#E91E63" cx="24" cy="23" r="2" />
            <circle
              fill="none"
              stroke="#F48FB1"
              stroke-width="2"
              stroke-miterlimit="10"
              cx="24"
              cy="23"
              r="4"
            />
            <circle
              fill="none"
              stroke="#F8BBD0"
              stroke-miterlimit="10"
              cx="24"
              cy="23"
              r="6.5"
            />
          </svg>
        </div>
        <h2 class="mb-4 text-center text-gray-700 text-1xl">
          Verify
          <b>Hotspot</b>
          Account
        </h2>
        <div class="px-12 pb-10">
          <p
            class="p-1 my-5 text-sm italic text-center text-green-600 bg-white border border-green-600 rounded-md"
          >
            Verifikasi menggunakan akun member kamu...!
          </p>
          <div class="w-full mb-2">
            <div class="flex items-center">
              <input
                autocomplete="off"
                bind:value={user}
                required
                type="text"
                id="user"
                placeholder="rmh-xxx"
                class="w-full px-3 py-2 text-2xl text-center text-gray-700 border rounded focus:outline-none"
              />
            </div>
          </div>
          <div class="w-full mb-2">
            <div class="flex items-center">
              <input
                autocomplete="off"
                bind:value={pass}
                required
                type="password"
                id="pass"
                placeholder="password"
                class="w-full px-3 py-2 text-2xl text-center text-gray-700 border rounded focus:outline-none"
              />
            </div>
          </div>
          <button
            type="submit"
            class="w-full px-5 py-2 text-gray-100 bg-green-600 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
          >
            VERIFY
          </button>
        </div>
      </form>
    </div>
  {/if}
</main>
